import React, { Component } from 'react';
import Url from 'c-url';
import notification  from 'c-notification';
import PbAjax from '../../../lib/pbajax';
import loading from 'c-up-loading';
import lang from '../../../lang';
import Modal from 'boron/ScaleModal';

let pbajax = new PbAjax();

// 发票信息
class InvoiceInfo extends Component{
    static defaultProps = {
        invoiceTypeList: [
            {   
                type: 2,
                text: lang.template('慈善捐款')
            },
            {
                type: 1,
                text: lang.template('索取發票')
            }
        ],
        product: null,
        orderBank: '',
        orderId: '',
        onClose: function(){}
    }

    constructor(props) {
        super(props);

        this.state = {
            btnCanSubmitType2: 0,
            btnCanSubmitType1: 0,
            invoiceType: 2,
            visible: 0, // 显示类型 0 不显示；1 显示
            email: '',
            realname: '',
            address: '',
            mobile: ''
        }
    }

    handleSubmit = ()=>{
        var vr = this.verifyForm();
        
        if (vr === true){
            // 验证通过，提交发票信息
            this.submit();
        } else {
            notification.simple(vr);
        }       
    }

    
    verifyForm(){
        let type = this.state.invoiceType;
        let email = this.state.email;
        let realname = this.state.realname;
        let address  = this.state.address;
        let mobile = this.state.mobile;

        let emailReg = /^([\.a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
        let result = true;

        if ( type == 1) {
            // 索取发票
            if (!emailReg.test(email)) {
                result = lang.template("請輸入正確的信箱");
            } 
            if (realname == '') {
                result = lang.template('請輸入真實姓名');
            }

            if (address == '') {
                result = lang.template('請輸入住宅地址');
            }

            if (mobile == '') {
                result = lang.template('請輸入手機號碼');
            }
        } else {
            if (!emailReg.test(email)) {
                result = lang.template("請輸入e-mail地址");
            } 
        }
        
        let obj = this.state;
        
        obj['btnCanSubmitType' + this.state.invoiceType] = (result === true ? 1 : 0);

        this.setState(obj);

        return result;
    }

    onInputChange = (key, e) =>{
        this.setValue(key, e.target.value.trim());
        this.verifyForm();
    }

    setValue(key, value){
        let obj = this.state;
        
        obj[key] = value;
        
        this.setState(obj);
    }

    onSelectType =(type) => {
        if (type == this.state.invoiceType) {
            return;
        }
        this.setState({
            invoiceType: type
        })
    }

    getInvoiceAPI() {
        const originMap = {
            stage: 'http://payment-test.upliveapps.com',
            pro: 'https://payment.upliveapps.com',
            dev: 'http://payment-test.upliveapps.com'
        }
        // 当前开发环境
        var env = Url.query('env');

        if (!env || env == 'null') {
            env = 'pro';
        }
        return originMap[env] || originMap['pro'];
    }


    submit() {
        let userInfo = UP.Global.getUser();

        let data = {
            uid: userInfo.uid,
            platform:'uplive', // 洋妞版本。银行汇款
            order_id: this.props.orderId,
            pay_bank: this.props.orderBank,
            invoice_type: this.state.invoiceType,
            email: this.state.email,
            t: +new Date()
        };
        
        if (this.state.invoiceType == 1) {
            // 索要
            Object.assign(data,{
                real_name:  this.state.realname,
                address: this.state.address,
                mobile: this.state.mobile
            });
        }

        let failCount = 0;

        let pushInvoice = (data)=>{
            let promise = $.ajax({
                url: this.getInvoiceAPI() + '/push/invoice',
                data: data,
                type: 'POST',
                timeout: 5 * 1000,
                dataType: 'json'
            });
            

            promise.done((res)=>{
                if (res.return_code == "SUCCESS"){
                    loading.hide();
                    this.showBankResult(res.pay_no);
                } else {
                    ++failCount;

                    if (failCount > 3) {
                        loading.hide();
                        notification.simple(res.return_code);   
                    } else {
                        pushInvoice(data);
                    }
                }
            });

            promise.fail(()=>{
                ++failCount;
                
                if (failCount > 3) {
                    loading.hide();
                } else {
                    pushInvoice(data);
                }
            })
        }

        loading.show();

        pushInvoice(data);
        
    }

    showBankResult(accountId){
        this.props.onSubmitSuccess(accountId);
    }

    onClose(){
        this.props.onClose();
    }

    render() {
        let disabled = this.state['btnCanSubmitType' + this.state.invoiceType] ? '' : 'disabled';
        let $content;

        if (this.state.invoiceType == 2) {
            $content = (
                <div className="input-content"> 
                    <div className="input-wrap">
                        <input type="text" placeholder={lang.template('請輸入e-mail地址')} value={this.state.email} name="email" ref="email" onChange={this.onInputChange.bind(this, 'email')} />            
                    </div>      
                </div>
            );
        } else {
            $content = (
                <div className="input-content">
                    <div className="input-wrap">
                        <input type="text" placeholder={lang.template('請輸入真實姓名')} value={this.state.realname} name="realname" ref="realname" onChange={this.onInputChange.bind(this, 'realname')} />
                        <input type="text" placeholder={lang.template('請輸入住宅地址')}  value={this.state.address} name="address" ref="address" onChange={this.onInputChange.bind(this, 'address')}   />         
                        <input type="text" placeholder={lang.template('請輸入手機號碼')} value={this.state.mobile}  name="mobile" ref="mobile" onChange={this.onInputChange.bind(this, 'mobile')} />           
                        <input type="text" placeholder={lang.template('請輸入e-mail地址')} value={this.state.email} name="email" ref="email"  onChange={this.onInputChange.bind(this, 'email')}  />          
                    </div>
                </div>
            );
        }

        return (
            <div className="bank-pop bank-invoice-pop">
                <div className="bank-pop-hd">
                    <h2>{lang.template('發票明細')}</h2>
                    <div className="close" onClick={this.onClose.bind(this)}></div>
                </div>
                <div className="bank-pop-bd">
                    <div className="tab-container">
                        <ul className="tab-nav">
                            {
                                this.props.invoiceTypeList.map((item, index)=>{
                                    let selected = item.type == this.state.invoiceType ? 'selected' : '';
                                    
                                    return (
                                        <li key={index} className={`tab ${selected}`} onClick={this.onSelectType.bind(this, item.type)}>{item.text}</li>
                                    );
                                })
                            }
                        </ul>
                        <div className="tab-panel">
                            {$content}
                            <ul className="notice">
                                <li dangerouslySetInnerHTML={{__html:lang.template('<em>1.慈善捐贈：</em>我們會將您的愛心傳遞給社會財團法人中華民國保護動物協會，謝謝您！網址：http://apate.org/')}}></li>
                                <li dangerouslySetInnerHTML={{__html:lang.template('<em>2.索取發票：</em>我們將於15個工作天內郵寄給您發票！')}}></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="bank-pop-ft">
                    <div className={`btn ${disabled}`} onClick={this.handleSubmit}>{lang.template('確定')}</div>
                </div>
            </div> 
        );
    }
}

export default InvoiceInfo;


// WEBPACK FOOTER //
// ./js/component/recharge/bank/invoice.js